/* HYP: default collections and search to in-stock only.
   - If a /collections/ or /search page loads with no availability filter in
     the URL, redirect once adding filter.v.availability=1 (In Stock ON).
   - If the shopper turns the In Stock switch OFF, remember it for the
     session (sessionStorage) and stop forcing the filter back on.
   - Crawlers hitting the clean canonical URL still get the full list
     server-side, and product pages are untouched, so SEO keeps everything.
   9/15/26 (LCP fix): internal links to collections now get the filter added
   at click time, so in-site navigation is ONE page load instead of a load
   followed by a redirect. The redirect still covers direct/external entries. */
(function () {
  'use strict';
  var KEY = 'hypShowSoldOut';

  function showSoldOut() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  try {
    var isCollection = /^\/collections\//.test(location.pathname);
    var isSearch = /^\/search\/?$/.test(location.pathname);

    if ((isCollection || isSearch) && !navigator.userAgent.match(/bot|crawl|spider|slurp|bing|duckduck/i)) {
      var qs = new URLSearchParams(location.search);

      if (!qs.has('filter.v.availability') && !showSoldOut()) {
        // On search, only force the filter when an actual query is present.
        if (isCollection || qs.has('q')) {
          qs.append('filter.v.availability', '1');
          location.replace(location.pathname + '?' + qs.toString() + location.hash);
        }
      }
    }
  } catch (e) { /* never block the page */ }

  // Add the filter to collection links before navigation (no redirect hop).
  document.addEventListener('click', function (e) {
    try {
      if (showSoldOut()) return;
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (!/^\/collections\/[^/]+\/?$/.test(url.pathname)) return;
      if (url.searchParams.has('filter.v.availability')) return;
      url.searchParams.append('filter.v.availability', '1');
      a.href = url.toString();
    } catch (err) { /* ignore */ }
  }, true);

  // Remember when the shopper deliberately shows sold-out items.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'filter.v.availability') return;
    try {
      if (t.checked) {
        sessionStorage.removeItem(KEY);
      } else {
        sessionStorage.setItem(KEY, '1');
      }
    } catch (err) { /* ignore */ }
  }, true);
})();
